import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://devexam.doode.in';

const StudentLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Check mobile width for responsive layout
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Check if token is expired
  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      return decoded.exp < Math.floor(Date.now() / 1000);
    } catch {
      return true; // invalid token format
    }
  };

  // Clear localStorage and redirect to login if session expired
  const handleTokenExpiry = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('student');
    localStorage.removeItem('id');
    alert('Session expired. Please log in again.');
    navigate('/student-login');
  };

  // On mount: check for existing token and expiry, clear if expired
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      if (isTokenExpired(token)) {
        console.log('Token expired on component mount.');
        handleTokenExpiry();
      } else {
        // Token valid: set axios default header for all requests
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const res = await axios.post('/api/student/auth/login', { username, password });

      if (res.data.message === 'Login successful' && res.data.student && res.data.token) {
        console.log('Login successful');

        const studentData = res.data.student;
        const token = res.data.token;

        // Save token and student data to localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('student', JSON.stringify(studentData));

        // Save student ID separately
        if (studentData._id) {
          localStorage.setItem('id', studentData._id);
          console.log('Stored student ID (_id):', studentData._id);
        } else if (studentData.id) {
          localStorage.setItem('id', studentData.id);
          console.log('Stored student ID (id):', studentData.id);
        } else {
          console.warn('No ID field found in student data');
          localStorage.removeItem('id'); // remove any stale id
        }

        // Set axios Authorization header globally for subsequent requests
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // Navigate to student dashboard
        navigate('/studentmark-dashboard');
      } else {
        setMessage('Unexpected response. Please try again.');
        console.error('Login response missing token or student:', res.data);
      }
    } catch (err) {
      console.error('Login error:', err);
      setMessage(err.response?.data?.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '100vh',
      }}
    >
      <div
        style={{
          flex: 1,
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9fafb',
          padding: '40px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            backgroundColor: '#fff',
            padding: '40px',
            borderRadius: '16px',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
          }}
        >
          <h2 style={{ textAlign: 'center', marginBottom: '24px', color: '#1f2937' }}>
            Student Login
          </h2>

          {message && (
            <div
              style={{
                backgroundColor: '#fee2e2',
                color: '#b91c1c',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '16px',
                textAlign: 'center',
              }}
            >
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
              }}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Link to="/student-forgot-password" style={{ fontSize: '14px', color: '#2563eb', textDecoration: 'none' }}>
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              style={{
                padding: '12px',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              Login
            </button>

            <div style={{ textAlign: 'center', marginTop: '8px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>or</span>
            </div>

            <Link to="/register" style={{ textDecoration: 'none' }}>
              <button
                type="button"
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: '#ffffff',
                  color: '#3b82f6',
                  border: '1px solid #3b82f6',
                  borderRadius: '12px',
                  fontSize: '16px',
                  cursor: 'pointer',
                }}
              >
                Register New Account
              </button>
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentLogin;
